import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState } from '..';
import { AuthService } from '@core/security/services/auth.service';
import { catchError, map, mergeMap, of, tap, withLatestFrom } from 'rxjs';
import * as oficinasActions from '../actions/oficinas.actions';
import * as accesosActions from '../actions/accesos.actions';
import { currentUser } from '../selectors/auth.selectors';
import { currentOffices } from '../selectors/oficinas.selectors';

@Injectable()
export class OficinasEffects {
	constructor(
		private actions$: Actions,
		private store: Store<AppState>,
		private auth: AuthService
	) {}

	cargarOficinas$ = createEffect(() =>
		this.actions$.pipe(
			ofType(oficinasActions.cargarOficinas),
			withLatestFrom(this.store.pipe(select(currentUser))),
			mergeMap(([action, user]) => {
				return this.auth.findAllSciOficinaByIdUsuario(user?.id ?? -1).pipe(
					map((usuarioOficina) =>
						oficinasActions.cargarOficinasSuccess({
							sciUsuarioOficina: usuarioOficina,
						})
					),
					catchError((err) =>
						of(
							oficinasActions.cargarOficinasError({
								payload: err,
							})
						)
					)
				);
			})
		)
	);

	cargarOficinasSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(oficinasActions.cargarOficinasSuccess),
				withLatestFrom(this.store.pipe(select(currentOffices))),
				tap(([, sciUsuarioOficina]) => {
					const oficinas = sciUsuarioOficina ?? [];
					const principal = oficinas.find(
						(o) => o.ctrlOficinaPrincipal || o.sciOficina?.ctrlOficinaPrincipal
					);
					const office = (principal ?? oficinas[0])?.sciOficina;

					if (!office?.idOficina) return;

					this.store.dispatch(
						oficinasActions.cambiarOficinaSeleccionada({
							sciOficina: office,
						})
					);
				})
			),
		{ dispatch: false }
	);

	cambiarOficinaSeleccionada$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(oficinasActions.cambiarOficinaSeleccionada),
				tap((action) => this.store.dispatch(accesosActions.cargarAccesos()))
			),
		{ dispatch: false }
	);
}
